// extracted by mini-css-extract-plugin
module.exports = {"dialog":"NavbarDayPicker_dialog__30H5x"};